import { on } from 'delegated-events'
import { slideToggle } from '../common/slide'

const fn = {
    init: () => {
        on('click', '.how-do-i-item .topic-title', fn.handleAccordian)
    },

    handleAccordian: (e) => {
        e.preventDefault()
        var target = e.target;

        var item = target.closest('.how-do-i-item')
        var title = target.closest('.topic-title')

        if (title.classList.contains('closed')) {
            title.classList.remove('closed')
            var img = title.getElementsByTagName('img')[0]
            img.style.transform = 'rotate(180deg)';
        }
        else {
            title.classList.add('closed')
            var img = title.getElementsByTagName('img')[0]
            img.style.transform = 'rotate(0deg)';
        }

        var contents = item.getElementsByClassName('how-do-i-content')
        var content = contents[0]
        slideToggle(content)

    }
}

export default {
    can: () => document.querySelector('.pagetype-howdoipage') || document.querySelector('.element-howdoielement'),
    run: fn.init,
}
